/* eslint-disable @typescript-eslint/no-require-imports */

import type ExpoAndroidAutoModule from "$modules/expo-android-auto/src/ExpoAndroidAutoModule";
import CustomPlatform from "$src/core/utils/platform/platform";

// The native impl is `.module.ts`, not `.native.ts`: Metro resolves `.native` on
// iOS too, which would crash with "Cannot find native module 'ExpoAndroidAuto'".
export default CustomPlatform.select<() => typeof ExpoAndroidAutoModule>({
  android: () => require("./src/ExpoAndroidAutoModule.module").default,
  default: () => require("./src/ExpoAndroidAutoModule").default,
})();
